import { render, staticRenderFns } from "./AdditionalReviewers.vue?vue&type=template&id=f847c606&scoped=true&"
import script from "./AdditionalReviewers.vue?vue&type=script&lang=js&"
export * from "./AdditionalReviewers.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalReviewers.vue?vue&type=style&index=0&id=f847c606&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f847c606",
  null
  
)

export default component.exports